<section class="university-panel">
  <h3 class="mb-2" i18n>Training &amp; Learning</h3>
  <p class="mb-3" i18n>
    Build the skills to architect, deploy, and operate secure identity solutions with Ping Identity training and
    enablement.
  </p>

  <div class="row g-4">
    <div class="col-12 col-md-6 col-xl-3 d-flex">
      <backstage-card [loading]="false" class="d-block h-100 w-100">
        <div card-header>
          <div class="mb-3">
            <backstage-color-bg-icon iconName="fork_right" color="red" [height]="3" [width]="3"/>
          </div>
          <h5 class="mb-0" i18n>Learning Pathways</h5>
        </div>
        <p card-body class="small text-muted mb-0" i18n>Our comprehensive learning pathways are designed to guide you
          from the foundational basics all the way through to expert-level mastery</p>
        <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/learning-pathways'" i18n>View
          pathways <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
      </backstage-card>
    </div>

    <div class="col-12 col-md-6 col-xl-3 d-flex">
      <backstage-card [loading]="false" class="d-block h-100 w-100">
        <div card-header>
          <div class="mb-3">
            <backstage-color-bg-icon iconName="play_circle" color="blue" [height]="3" [width]="3"/>
          </div>
          <h5 class="mb-0" i18n>On-Demand Learning</h5>
        </div>
        <p card-body class="small text-muted mb-0" i18n>Learn at your own pace with guided identity training.</p>
        <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/on-demand'" i18n>Start learning
          <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
      </backstage-card>
    </div>

    <div class="col-12 col-md-6 col-xl-3 d-flex">
      <backstage-card [loading]="false" class="d-block h-100 w-100">
        <div card-header>
          <div class="mb-3">
            <backstage-color-bg-icon iconName="event" color="cyan" [height]="3" [width]="3"/>
          </div>
          <h5 class="mb-0" i18n>Event Calendar</h5>
        </div>
        <p card-body class="small text-muted mb-0" i18n>Join upcoming live sessions, workshops, and events.</p>
        <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/events'" i18n>View events <i
          class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
      </backstage-card>
    </div>

    <div class="col-12 col-md-6 col-xl-3 d-flex">
      <backstage-card [loading]="false" class="d-block h-100 w-100">
        <div card-header>
          <div class="mb-3">
            <backstage-color-bg-icon iconName="workspace_premium" color="green" [height]="3" [width]="3"/>
          </div>
          <h5 class="mb-0" i18n>Certification</h5>
        </div>
        <p card-body class="small text-muted mb-0" i18n>Validate your expertise with Ping Identity certifications.</p>
        <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/certification'" i18n>Get
          certified <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
      </backstage-card>
    </div>

    @if ('community' | hasRole) {
      <div class="col-12 col-md-6 col-xl-3 d-flex">
        <backstage-card [loading]="false" class="d-block h-100 w-100">
          <div card-header>
            <div class="mb-3">
              <backstage-color-bg-icon iconName="military_tech" color="purple" [height]="3" [width]="3"/>
            </div>
            <h5 class="mb-0" i18n>My Badges</h5>
          </div>
          <p card-body class="small text-muted mb-0" i18n>View the badges and achievements you've earned through training.</p>
          <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/my-training/account'" i18n>View badges
            <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
        </backstage-card>
      </div>

      <div class="col-12 col-md-6 col-xl-3 d-flex">
        <backstage-card [loading]="false" class="d-block h-100 w-100">
          <div card-header>
            <div class="mb-3">
              <backstage-color-bg-icon iconName="card_membership" color="yellow" [height]="3" [width]="3"/>
            </div>
            <h5 class="mb-0" i18n>Training Subscriptions</h5>
          </div>
          <p card-body class="small text-muted mb-0" i18n>View and manage your active training subscriptions and plans.</p>
          <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/my-training/training-subscriptions'" i18n>Manage
            subscriptions <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
        </backstage-card>
      </div>

      <div class="col-12 col-md-6 col-xl-3 d-flex">
        <backstage-card [loading]="false" class="d-block h-100 w-100">
          <div card-header>
            <div class="mb-3">
              <backstage-color-bg-icon iconName="checklist" color="blue" [height]="3" [width]="3"/>
            </div>
            <h5 class="mb-0" i18n>My Enrollments</h5>
          </div>
          <p card-body class="small text-muted mb-0" i18n>Review your active learning enrollments.</p>
          <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/enrollments'" i18n>View
            enrollments <i class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
        </backstage-card>
      </div>

      <div class="col-12 col-md-6 col-xl-3 d-flex">
        <backstage-card [loading]="false" class="d-block h-100 w-100">
          <div card-header>
            <div class="mb-3">
              <backstage-color-bg-icon iconName="receipt_long" color="green" [height]="3" [width]="3"/>
            </div>
            <h5 class="mb-0" i18n>My Orders</h5>
          </div>
          <p card-body class="small text-muted mb-0" i18n>View training purchases and order history.</p>
          <a card-footer class="btn-link p-0 text-decoration-none" [href]="trainingUrl + '/orders'" i18n>View orders <i
            class="bi bi-chevron-right ms-1" aria-hidden="true"></i></a>
        </backstage-card>
      </div>
    }
  </div>
</section>
